let TAGS: { [tag: string]: string } = {};
export const updateSentryTags = (tags: { [tag: string]: string }) => {
  TAGS = { ...TAGS, ...tags };
};

export const getSentryTags = () => TAGS;
